class Storage {
    static getItem(key, parse = true) {
        let value = localStorage.getItem(key)

        let result
        if (!parse) return value
        try {
            result = JSON.parse(value)
        } catch {
            result = undefined
        }
        return result
    }

    static removeItem(key) {
        localStorage.removeItem(key)
    }
    static setItem(key, value) {
        localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value))
    }
}

export { Storage }
